import React from 'react';
import {  Route, Navigate } from 'react-router-dom';

const PublicRoute = ({ component: Component, user, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        user
          ? <Navigate to={{ pathname: '/error/404' }} />
          : <Component user={user} {...props} />}
    />
  );
  export default PublicRoute;
